'use client';
import { Box, Button, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface MobileTradeButtonProps {
  onClick: () => void;
  disabled: boolean;
  buttonText: string;
}

export function MobileTradeButton({ onClick, disabled, buttonText }: MobileTradeButtonProps) {
  const { t } = useT();
  return (
    <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Button
        fullWidth
        variant="contained"
        onClick={onClick}
        disabled={disabled}
        sx={{
          bgcolor: '#2563eb', // Standard primary blue
          color: '#ffffff',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: '1.125rem',
          py: 1.5,
          borderRadius: '10px',
          boxShadow: 'none',
          '&:hover': {
            bgcolor: '#1d4ed8',
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            bgcolor: 'action.disabledBackground',
            color: 'action.disabled',
          },
        }}
      >
        {buttonText}
      </Button>
      <Box sx={{ mt: 1, textAlign: 'center' }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
          {t('trade.termsDisclaimer')}{' '}
          <Button
            component="a"
            href="/terms"
            sx={{
              minWidth: 'auto',
              p: 0,
              fontSize: '0.75rem',
              color: 'text.secondary',
              textDecoration: 'underline',
              textTransform: 'none',
              verticalAlign: 'baseline',
              '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
            }}
          >
            {t('trade.termsOfUse')}
          </Button>
        </Typography>
      </Box>
    </Box>
  );
}
